<li>
  <div class="flex items-center">
    <vti-icons [icon]="'arrow-right'" color="vti" colorTint="400"></vti-icons>
    @if (routerLink()) {
      <div>
        <a [routerLink]="routerLink()" class="sm:ml-4 text-sm font-medium text-vti-500 hover:text-vti-700">{{ text() }}</a>
      </div>
    } @else {
      <span class="sm:ml-4 text-sm font-medium">{{ text() }}</span>
    }
  </div>
</li>
